import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, roles }) => {
    const { token, user } = useAuth();

    // 🔒 Not authenticated
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // 🔒 No user data
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // 🔒 Role check (optional)
    if (roles && roles.length > 0) {
        const userRole = user.role?.toLowerCase();

        if (!userRole) {
            return <Navigate to="/unauthorized" replace />;
        }

        const isAllowed = roles.some(
            (r) => r.toLowerCase() === userRole
        );

        if (!isAllowed) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    // ✅ OK → render children
    return children;
};

export default ProtectedRoute;